export default "__VITE_ASSET___x0gdFhJ__"